var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CalendarWebpart',{attrs:{"option":_vm.webPartItem}})
}
var staticRenderFns = []

export { render, staticRenderFns }